import { Search, X } from "lucide-react";
import { cn } from "@/lib/cn";

/** Busca das seções do catálogo. Filtra na tela: as listas já vêm inteiras do servidor e são de
 *  dezenas de itens, então ida ao servidor a cada tecla só atrasaria a resposta. */
export function CatalogoBusca({
  valor,
  onChange,
  placeholder,
  achados,
  className,
}: {
  valor: string;
  onChange: (v: string) => void;
  placeholder: string;
  /** Quantos itens sobraram — só aparece enquanto há busca. */
  achados?: number;
  /** Sobrepõe a margem de cima (ex.: `mt-0` pra alinhar com colunas vizinhas). */
  className?: string;
}) {
  return (
    <div className={cn("mt-2 flex items-center gap-2", className)}>
      <div className="relative flex-1">
        <Search className="pointer-events-none absolute left-2.5 top-1/2 h-3.5 w-3.5 -translate-y-1/2 text-zinc-400" />
        <input
          value={valor}
          onChange={(e) => onChange(e.target.value)}
          placeholder={placeholder}
          aria-label={placeholder}
          className="h-8 w-full rounded-md border border-zinc-200 bg-white pl-8 pr-7 text-xs text-zinc-900 placeholder:text-zinc-400 focus:border-brand-500 focus:outline-none focus:ring-1 focus:ring-brand-500 dark:border-border dark:bg-card dark:text-foreground"
        />
        {valor && (
          <button
            type="button"
            onClick={() => onChange("")}
            aria-label="Limpar busca"
            className="absolute right-1.5 top-1/2 -translate-y-1/2 rounded p-0.5 text-zinc-400 hover:bg-zinc-100 hover:text-zinc-700 dark:hover:bg-white/10"
          >
            <X className="h-3.5 w-3.5" />
          </button>
        )}
      </div>
      {valor && achados != null && (
        <span className="shrink-0 text-[11px] tabular-nums text-zinc-500 dark:text-muted-foreground">
          {achados === 0 ? "nada encontrado" : `${achados} ${achados === 1 ? "resultado" : "resultados"}`}
        </span>
      )}
    </div>
  );
}

/** Compara ignorando acento e caixa — quem busca "conten" quer achar "Contenção". */
export function combina(texto: string | null | undefined, busca: string) {
  if (!busca) return true;
  const normaliza = (s: string) => s.normalize("NFD").replace(/[\u0300-\u036f]/g, "").toLowerCase();
  return normaliza(texto ?? "").includes(normaliza(busca));
}
